import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Flag, SearchCheck } from 'lucide-react';
import Header from '../components/layout/Header';
import { api } from '../services/api';

export default function SignalementsPage() {
  const [signalements, setSignalements] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    api.getSignalements().then((items) => { if (mounted) setSignalements(items); }).finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const openAnalysis = (item) => {
    if (item.analysis) navigate('/results', { state: { type: item.analysis.type, data: item.analysis } });
  };

  return (
    <div className="page-container">
      <Header showBack backLabel="Mes signalements" onBack={() => navigate(-1)} />
      <section className="mx-4 mt-6">
        <h1 className="text-2xl font-extrabold text-brand-navy">Mes signalements</h1>
        <p className="mt-2 text-sm text-text-muted">Suivez les dossiers transmis aux autorités compétentes.</p>
      </section>
      {loading ? <p className="mx-4 mt-10 text-center text-text-muted">Chargement des signalements...</p> : null}
      {!loading && !signalements.length ? <EmptySignalements onHistory={() => navigate('/history')} /> : null}
      <section className="mx-4 mt-6 space-y-3 md:grid md:grid-cols-2 xl:grid-cols-3 md:gap-3 md:space-y-0">
        {signalements.map((item) => (
          <button key={item.id} type="button" onClick={() => openAnalysis(item)} className="card w-full text-left flex gap-4 items-start active:scale-[0.99] transition-transform" aria-label={`Ouvrir le signalement ${item.ref}`}>
            <span className="w-12 h-12 rounded-xl bg-brand-navy/10 text-brand-navy flex items-center justify-center"><Flag className="w-6 h-6" /></span>
            <span className="flex-1 min-w-0"><span className="font-mono text-xs text-accent-blue">{item.ref}</span><span className="block font-bold text-text-primary truncate mt-1">{item.title}</span><span className="block text-sm text-text-muted mt-1">{item.authority} · {item.date}</span><span className="mt-3 inline-flex items-center gap-2 rounded-full bg-verdict-safe-bg text-verdict-safe px-3 py-1 text-xs font-semibold"><SearchCheck className="w-4 h-4" />{item.status}</span></span>
            <ChevronRight className="w-5 h-5 text-text-subtle mt-3" />
          </button>
        ))}
      </section>
    </div>
  );
}

function EmptySignalements({ onHistory }) {
  return (
    <div className="mx-4 mt-10 card text-center py-8">
      <Flag className="w-12 h-12 mx-auto text-text-subtle" />
      <h2 className="mt-4 font-bold text-brand-navy">Aucun signalement</h2>
      <p className="mt-2 text-sm text-text-muted">Ouvrez une analyse dangereuse ou suspecte pour envoyer un signalement.</p>
      <button type="button" onClick={onHistory} className="btn-primary mt-5">Voir l'historique</button>
    </div>
  );
}
